/* import __COLOCATED_TEMPLATE__ from './sq-button-window.hbs.js'; */
/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import { computed, set } from '@ember/object';
import Component from '@ember/component';
import { inject as service } from '@ember/service';

/**
`SqButtonWindowComponent` is mostly a wrapper around the CSS/HTML for a
Button Window. These are basically boxes with whatever you pass into them
(this is the "window") and a button fixed at the bottom.

These can be used for marketing around different options (showing logos, etc)
or previewing the effects of the button itself, such as in our `SqImageUploader`.

The CSS handles making the button hover/active when hovering/clicking anywhere on the
component. The one bit of functionality this component adds is triggering the
passed `action` whether clicking the window or the button. Which is kind of important.

```example
@title Simple Example

@controller-properties
{
  actions: {
    foo() {
      console.log("Foo");
    }
  }
}

@hbs
{{#sq-button-window action=(action "foo")}}
  <div style="height: 200px; width: 200px; background: navy;"></div>
{{/sq-button-window}}
```
*/

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  i18n: service(),
  classNames: 'button-window',
  buttonClass: 'button--blue-link',
  label: computed('_label', 'i18n', {
    get() {
      if (this._label) {
        return this._label;
      }
      return this.i18n.t('button.select');
    },
    set(_, value) {
      return set(this, '_label', value);
    }
  }),
  disabled: false
});